import { BAND_COLORS } from "../bands";

// FFS — Five-Factor Score (1996, French Vasculitis Study Group).
// Five prognostic factors, each present scores 1 point (total 0–5). The score
// maps to 5-year mortality / survival and a relative risk of death.
// ⚠️ Verify the outcome figures clinically before use.
const FACTORS = [
    "Proteinuria > 1 g/24 h",
    "Reduced renal function (creatinine >1.58 mg/dl or 140 µmol/l)",
    "Gastrointestinal hemorrhage, infarction, or pancreatitis",
    "Cardiomyopathy",
    "Involvement of the central nervous system",
];

// 5-year survival + relative risk of death by score (Guillevin 1996).
const OUTCOMES = {
    0: { survival: "88.1%", rr: "0.62", color: BAND_COLORS.remission },
    1: { survival: "74.1%", rr: "1.35", color: BAND_COLORS.moderate },
    high: { survival: "54%", rr: "2.6", color: BAND_COLORS.high }, // FFS ≥ 2
};

const FIELDS = FACTORS.map((label, i) => ({
    key: `f${i}`,
    type: "toggle",
    label,
    default: 0,
}));

export const ffs = {
    id: "ffs",
    name: "Five-Factor Score",
    subtitle: "Prognostic score for systemic necrotising vasculitides",
    group: "Vasculitis",
    status: "ready",
    layout: "compact",
    options: [],
    fields: FIELDS,
    compute: (v) => FIELDS.reduce((sum, f) => sum + (Number(v[f.key]) || 0), 0),
    interpret: (score) => {
        const o = score >= 2 ? OUTCOMES.high : OUTCOMES[score];
        return { label: `5-year survival ${o.survival} · RR ${o.rr}`, color: o.color };
    },
    about:
        "The Five-Factor Score (FFS) is a five-point system developed by the French Vasculitis Study Group to predict the risk of death in systemic necrotising vasculitides (polyarteritis nodosa, microscopic polyangiitis, and eosinophilic granulomatosis with polyangiitis / Churg-Strauss syndrome). Each factor present scores 1 point. 5-year mortality rises with the score: FFS 0 ≈ 11.9%, FFS 1 ≈ 25.9%, FFS ≥2 ≈ 46%.",
    references: [
        "Guillevin L, et al. Prognostic factors in polyarteritis nodosa and Churg-Strauss syndrome: a prospective study in 342 patients (the Five-Factor Score). Medicine (Baltimore). 1996.",
    ],
};
